import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: CrumbItem[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          )}
          {item.to ? (
            <Link
              to={item.to}
              className="whitespace-nowrap transition-colors hover:text-accent-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap font-medium text-foreground-950">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}